<template>
    <v-container class="fill-height" style="display: block;" fluid>
        <v-row>
            <v-col cols="12" lg="6">
                <v-card outlined class="card">
                    <v-card-title>
                        Assign Sounds
                        <v-icon class="setting-scope-icon">mdi-account</v-icon>
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="card-body">
                        <v-row>
                            <v-col cols="12" sm="9" md="10">
                                <v-select label="Broadcast Sound" v-model="$props.soundSettings.broadcastSound" color="#c42111" :items="$store.state.audioFiles" item-text="name" item-value="name">
                                    <v-icon slot="prepend" class="mt-1" color="#FB8C00">mdi-alert</v-icon>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="3" md="2">
                                <v-switch v-model="$props.soundSettings.broadcastSoundActive" label="Off/On" color="#c42111" />
                            </v-col>

                            <v-col cols="12" sm="9" md="10">
                                <v-select label="New Chat Message Sound" v-model="$props.soundSettings.newChatMessageSound" color="#c42111" :items="$store.state.audioFiles" item-text="name" item-value="name">
                                    <v-icon slot="prepend" class="mt-1" color="#ffffff">mdi-comment-alert</v-icon>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="3" md="2">
                                <v-switch v-model="$props.soundSettings.newChatMessageSoundActive" label="Off/On" color="#c42111" />
                            </v-col>

                            <v-col cols="12" sm="9" md="10">
                                <v-select label="Critical Alarm Sound" v-model="$props.soundSettings.criticalAlarmSound" color="#c42111" :items="$store.state.audioFiles" item-text="name" item-value="name">
                                    <v-icon slot="prepend" class="mt-1" :color="$store.state.batchConfig.webapp_settings.alarms.alarmColors.critical.new.background">mdi-bell-ring</v-icon>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="3" md="2">
                                <v-switch v-model="$props.soundSettings.criticalAlarmSoundActive" label="Off/On" color="#c42111" />
                            </v-col>

                            <v-col cols="12" sm="9" md="10">
                                <v-select label="Major Alarm Sound" v-model="$props.soundSettings.majorAlarmSound" color="#c42111" :items="$store.state.audioFiles" item-text="name" item-value="name">
                                    <v-icon slot="prepend" class="mt-1" :color="$store.state.batchConfig.webapp_settings.alarms.alarmColors.major.new.background">mdi-bell-ring</v-icon>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="3" md="2">
                                <v-switch v-model="$props.soundSettings.majorAlarmSoundActive" label="Off/On" color="#c42111" />
                            </v-col>

                            <v-col cols="12" sm="9" md="10">
                                <v-select label="Minor Alarm Sound" v-model="$props.soundSettings.minorAlarmSound" color="#c42111" :items="$store.state.audioFiles" item-text="name" item-value="name">
                                    <v-icon slot="prepend" class="mt-1" :color="$store.state.batchConfig.webapp_settings.alarms.alarmColors.minor.new.background">mdi-bell-ring</v-icon>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="3" md="2">
                                <v-switch v-model="$props.soundSettings.minorAlarmSoundActive" label="Off/On" color="#c42111" />
                            </v-col>

                            <v-col cols="12" sm="9" md="10">
                                <v-select label="Observational Alarm Sound" v-model="$props.soundSettings.observationalAlarmSound" color="#c42111" :items="$store.state.audioFiles" item-text="name" item-value="name">
                                    <v-icon slot="prepend" class="mt-1" :color="$store.state.batchConfig.webapp_settings.alarms.alarmColors.observational.new.background">mdi-bell-ring</v-icon>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="3" md="2">
                                <v-switch v-model="$props.soundSettings.observationalAlarmSoundActive" label="Off/On" color="#c42111" />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" lg="6">
                <v-card outlined class="card">
                    <v-card-title>
                        Available Sounds
                        <v-icon class="setting-scope-icon">mdi-account-group</v-icon>
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="card-body">

                        <v-simple-table dark>
                            <template v-slot:default>
                            <thead>
                                <tr>
                                    <th width="45px"></th>
                                    <th class="text-left">Name</th>
                                    <th class="text-left">Type</th>
                                    <th class="text-left">Size</th>
                                    <th class="text-left"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(fileMeta, index) in $store.state.audioFiles" :key="index">
                                    <td class="text-center" width="45px">
                                        <v-btn icon @click="playAudioFile(fileMeta.name)" v-if="!(playAudioFileName == fileMeta.name) && !fileMeta.uploading"><v-icon>mdi-play</v-icon></v-btn>
                                        <v-icon v-if="playAudioFileName == fileMeta.name && !fileMeta.uploading">fas fa-circle-notch fa-spin</v-icon>
                                    </td>
                                    <td class="text-left">{{ fileMeta.name }}</td>
                                    <td>{{ fileMeta.type }}</td>
                                    <td>{{ getReadableFileSize(fileMeta.size) }}</td>
                                    <td class="text-right">
                                        <v-btn icon @click="deleteAudioFileClick(fileMeta.name)" v-if="!fileMeta.uploading" :disabled="!addRemovePermissions"><v-icon>mdi-delete</v-icon></v-btn>
                                        <v-progress-linear v-if="fileMeta.uploading && fileMeta.uploadProgress != 100" :value="fileMeta.uploadProgress" color="#c42111" />
                                        <span v-if="fileMeta.uploading && fileMeta.uploadProgress == 100">processing <v-icon>fas fa-spinner fa-spin</v-icon></span>
                                    </td>
                                </tr>
                            </tbody>
                            </template>
                        </v-simple-table>

                    </v-card-text>
                    <v-divider />
                    <v-card-actions>
                        <v-btn text @click="showUploadAudioFile = true" :disabled="!addRemovePermissions">Add New</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        
        <v-dialog v-model="showUploadAudioFile" max-width="80%" width="700px" persistent v-if="showUploadAudioFile">
            <audio-file-upload @close="showUploadAudioFile = false" @save="saveAudioFile"></audio-file-upload>
        </v-dialog>

        <audio :src="playAudioFileData" style="outline: none; width: 100%;" autoplay @play="onPlay" @ended="onEnd"></audio>

    </v-container>
</template>

<script>
import AudioFileUpload from "@/components/Settings/AudioFileUpload";
export default {
    name: 'Sounds',
    props: ['soundSettings'],
    components: {
        AudioFileUpload
    },
    data: () => ({
        showUploadAudioFile: false,
        playAudioFileData: null,
        playAudioFileName: null,
        uploadingFile: null
    }),

    computed: {
        addRemovePermissions: function() {
            return TELSA.checkPermission(this.$store.state.user, 'admin/alarm/*');
        }
    },

    methods: {
        saveAudioFile: function(audioFile) {
            this.showUploadAudioFile = false;
            this.$store.dispatch('addAudioFile', audioFile);
        },

        playAudioFile: function(audioFileName) {
            this.playAudioFileName = audioFileName;
            TELSA.IDB.get('audioFileStore', audioFileName).then(response => {
                this.playAudioFileData = response.data;
            });
        },

        deleteAudioFileClick: function(audioFileName) {
            this.$store.commit('showConfirmModal', {
                title: 'Delete Audio File',
                message: `This operation will permanently delete <b>${audioFileName}</b> and make it unavailable for any paging rules. Are you sure you want to do this?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteAudioFile(audioFileName)
            });
        },
        deleteAudioFile: function(audioFileName) {
            this.$store.dispatch('deleteAudioFile', audioFileName);
        },

        onPlay: function() {
        },
        onEnd: function(thing) {
            this.playAudioFileName = null;
            this.playAudioFileData = null;
        },

        getReadableFileSize: function(size) {
            return TELSA.readableFileSize(size);
        },



    },

    mounted() {

    }

  
};
</script>

<style scoped>

    .card {
        overflow-y: auto;
        max-height: calc(100vh - 224px);
        /* height: calc(100vh - 242px); */
        position: relative;
    }

    .card-body {
        overflow-y: auto;
        /* height: calc(100% - 65px); */
        max-height: calc(100vh - 310px);
        position: relative;
    }

</style>
